import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    useDisclosure,
} from '@nextui-org/react';
import ControlledInput from '../../../elements/ControlledInput';
import toast from 'react-hot-toast';
import { PlusIcon } from '@heroicons/react/24/outline';
import { postFetcher } from '../../../../services/api';
import { yupResolver } from '@hookform/resolvers/yup';
import { dataPICValidation } from '../../../../services/validation';
import ControlledReactSelect from '../../../elements/ControlledReactSelect';
import useListCompany from '../../../../hooks/useListCompany';

export default function DataPICSelector({ type, mutatePIC, selectedCompany }) {
    const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();
    const { dataCompany, isLoadingCompany } = useListCompany()
    const {
        control: controlModal,
        handleSubmit: handleSubmitModal,
        reset: resetModal,
        formState: { isSubmitting: isSubmittingModal },
    } = useForm({ resolver: yupResolver(dataPICValidation) });

    useEffect(() => {
        if (selectedCompany) {
            resetModal({
                companyId: selectedCompany
            })
        }
      }, [selectedCompany, resetModal])

    const handleAddPIC = async (formData) => {
        try {
            formData.type = type;
            if(selectedCompany){
                formData.companyId = selectedCompany;
            }
            await postFetcher('/api/company/create-data-pic', formData);
            mutatePIC();
            toast.success('DataPIC berhasil ditambahkan!');
            onClose();
        } catch (error) {
            toast.error('Gagal menambahkan DataPIC.');
        }
    };

    const openAddModal = () => {
        resetModal({
            namaPIC: '',
            jabatan: '',
            email: '',
            telepon: '',
            fax: '',
        });
        onOpen();
    };

    return (
        <div className='flex flex-col justify-end'>
            <Button onPress={openAddModal} color="primary" startContent={<PlusIcon className="size-4" />}>
              Tambah PIC
            </Button>

            <Modal scrollBehavior='inside' size="xl" isOpen={isOpen} onOpenChange={onOpenChange} isDismissable={false}>
                <ModalContent>
                    <ModalHeader>Tambah DataPIC</ModalHeader>
                    <ModalBody>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
                            {!selectedCompany &&
                            (<ControlledReactSelect
                                label="Perusahaan"
                                control={controlModal}
                                options={dataCompany?.data?.map((item) => ({ label: item.name, value: item.id }))}
                                isLoading={isLoadingCompany}
                                name="companyId"
                            />)}
                            <ControlledInput label="Nama PIC" name="namaPIC" control={controlModal} isRequired />
                            <ControlledInput label="Jabatan" name="jabatan" control={controlModal} isRequired />
                            <ControlledInput label="No Handphone" name="telepon" control={controlModal} isRequired />
                            <ControlledInput label="Email" name="email" control={controlModal} isRequired />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button onPress={handleSubmitModal(handleAddPIC)} isLoading={isSubmittingModal} color="primary">
                            Tambah
                        </Button>
                        <Button color="danger" variant="faded" onPress={onClose}>
                            Batal
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </div>
    );
}
